let base_url:string = 'https://manyataapi.dhwaniris.in/web/api/';

export const environment = {
  SUPERSECRET: "eDrrr8nTQFODFyVs",
  production: false,
  base_url: base_url
};



